<script>
  import { draw } from 'svelte/transition'
  import { onMount } from 'svelte'

  let guides
  let showGuides = false
  let scroller
  onMount(() => {
    scroller = ScrollTrigger.create({
      trigger: guides,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => {
        showGuides = !showGuides
      },
      onLeaveBack: () => {
        showGuides = !showGuides
      },
    })
    return () => {
      scroller.kill()
    }
  })
</script>

<div bind:this={guides}>
  {#if showGuides}
    <svg
      id="Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1801.01 844.77">
      <defs>
        <style>
          .cls-4 {
            fill: none;
            stroke: #3d3a36;
            stroke-miterlimit: 10;
            stroke-width: 6px;
          }
        </style>
      </defs>
      <line
        in:draw={{ duration: 600, delay: 1000 }}
        class="cls-4"
        x1="0.44"
        y1="384.01"
        x2="1766.13"
        y2="384.01" />
    </svg>
  {/if}
</div>
